/* Places offered by LocationInput.

   Bundled rather than fetched from a geocoding service: no API key, no per-call
   cost, no third-party host for the app's CSP to allow, and it answers on the
   first keystroke inside an in-app browser with a bad connection.

   Indiana is listed in full and first because that is where the customers and
   almost all of the traffic are. The rest is the largest US cities, plus each
   state for anyone hiring statewide, plus Remote. 411 entries, and free
   text still works for anywhere not on it.

   Generated, but committed rather than built at runtime -- it changes about
   never, and a build step for a static list is a build step to maintain. */
const US_PLACES = [
  "Remote",
  "Indianapolis, IN",
  "Carmel, IN",
  "Fishers, IN",
  "Noblesville, IN",
  "Westfield, IN",
  "Zionsville, IN",
  "Greenwood, IN",
  "Fort Wayne, IN",
  "Evansville, IN",
  "South Bend, IN",
  "Bloomington, IN",
  "Lafayette, IN",
  "West Lafayette, IN",
  "Muncie, IN",
  "Terre Haute, IN",
  "Kokomo, IN",
  "Anderson, IN",
  "Elkhart, IN",
  "Mishawaka, IN",
  "Columbus, IN",
  "Jeffersonville, IN",
  "New Albany, IN",
  "Richmond, IN",
  "Valparaiso, IN",
  "Merrillville, IN",
  "Hammond, IN",
  "Gary, IN",
  "Portage, IN",
  "Michigan City, IN",
  "Marion, IN",
  "Logansport, IN",
  "Plainfield, IN",
  "Brownsburg, IN",
  "Avon, IN",
  "Danville, IN",
  "Franklin, IN",
  "Shelbyville, IN",
  "Lebanon, IN",
  "Crawfordsville, IN",
  "Frankfort, IN",
  "Peru, IN",
  "Wabash, IN",
  "Huntington, IN",
  "Warsaw, IN",
  "Goshen, IN",
  "Auburn, IN",
  "Angola, IN",
  "Bedford, IN",
  "Seymour, IN",
  "Madison, IN",
  "Vincennes, IN",
  "Washington, IN",
  "Jasper, IN",
  "Greencastle, IN",
  "New York, NY",
  "Los Angeles, CA",
  "Chicago, IL",
  "Houston, TX",
  "Phoenix, AZ",
  "Philadelphia, PA",
  "San Antonio, TX",
  "San Diego, CA",
  "Dallas, TX",
  "Jacksonville, FL",
  "Austin, TX",
  "Fort Worth, TX",
  "San Jose, CA",
  "Columbus, OH",
  "Charlotte, NC",
  "San Francisco, CA",
  "Seattle, WA",
  "Denver, CO",
  "Oklahoma City, OK",
  "Nashville, TN",
  "Washington, DC",
  "El Paso, TX",
  "Las Vegas, NV",
  "Boston, MA",
  "Detroit, MI",
  "Portland, OR",
  "Louisville, KY",
  "Memphis, TN",
  "Baltimore, MD",
  "Milwaukee, WI",
  "Albuquerque, NM",
  "Tucson, AZ",
  "Fresno, CA",
  "Sacramento, CA",
  "Mesa, AZ",
  "Atlanta, GA",
  "Kansas City, MO",
  "Colorado Springs, CO",
  "Omaha, NE",
  "Raleigh, NC",
  "Miami, FL",
  "Long Beach, CA",
  "Virginia Beach, VA",
  "Oakland, CA",
  "Minneapolis, MN",
  "Tulsa, OK",
  "Bakersfield, CA",
  "Wichita, KS",
  "Arlington, TX",
  "Aurora, CO",
  "Tampa, FL",
  "New Orleans, LA",
  "Cleveland, OH",
  "Honolulu, HI",
  "Anaheim, CA",
  "Lexington, KY",
  "Stockton, CA",
  "Corpus Christi, TX",
  "Henderson, NV",
  "Riverside, CA",
  "Newark, NJ",
  "Saint Paul, MN",
  "Santa Ana, CA",
  "Cincinnati, OH",
  "Irvine, CA",
  "Orlando, FL",
  "Pittsburgh, PA",
  "St. Louis, MO",
  "Greensboro, NC",
  "Jersey City, NJ",
  "Anchorage, AK",
  "Lincoln, NE",
  "Plano, TX",
  "Durham, NC",
  "Buffalo, NY",
  "Chandler, AZ",
  "Chula Vista, CA",
  "Toledo, OH",
  "Madison, WI",
  "Gilbert, AZ",
  "Reno, NV",
  "North Las Vegas, NV",
  "St. Petersburg, FL",
  "Lubbock, TX",
  "Irving, TX",
  "Laredo, TX",
  "Winston-Salem, NC",
  "Chesapeake, VA",
  "Glendale, AZ",
  "Scottsdale, AZ",
  "Garland, TX",
  "Boise, ID",
  "Norfolk, VA",
  "Spokane, WA",
  "Fremont, CA",
  "Richmond, VA",
  "Santa Clarita, CA",
  "San Bernardino, CA",
  "Baton Rouge, LA",
  "Hialeah, FL",
  "Tacoma, WA",
  "Modesto, CA",
  "Port St. Lucie, FL",
  "Huntsville, AL",
  "Des Moines, IA",
  "Moreno Valley, CA",
  "Fontana, CA",
  "Frisco, TX",
  "Rochester, NY",
  "Yonkers, NY",
  "Fayetteville, NC",
  "Worcester, MA",
  "Columbus, GA",
  "Cape Coral, FL",
  "McKinney, TX",
  "Little Rock, AR",
  "Oxnard, CA",
  "Amarillo, TX",
  "Augusta, GA",
  "Salt Lake City, UT",
  "Montgomery, AL",
  "Birmingham, AL",
  "Grand Rapids, MI",
  "Grand Prairie, TX",
  "Overland Park, KS",
  "Tallahassee, FL",
  "Huntington Beach, CA",
  "Sioux Falls, SD",
  "Peoria, AZ",
  "Knoxville, TN",
  "Glendale, CA",
  "Vancouver, WA",
  "Providence, RI",
  "Akron, OH",
  "Brownsville, TX",
  "Mobile, AL",
  "Newport News, VA",
  "Tempe, AZ",
  "Shreveport, LA",
  "Chattanooga, TN",
  "Fort Lauderdale, FL",
  "Aurora, IL",
  "Elk Grove, CA",
  "Ontario, CA",
  "Salem, OR",
  "Cary, NC",
  "Santa Rosa, CA",
  "Rancho Cucamonga, CA",
  "Eugene, OR",
  "Oceanside, CA",
  "Clarksville, TN",
  "Garden Grove, CA",
  "Lancaster, CA",
  "Springfield, MO",
  "Pembroke Pines, FL",
  "Fort Collins, CO",
  "Palmdale, CA",
  "Salinas, CA",
  "Hayward, CA",
  "Corona, CA",
  "Paterson, NJ",
  "Murfreesboro, TN",
  "Macon, GA",
  "Lakewood, CO",
  "Killeen, TX",
  "Springfield, MA",
  "Alexandria, VA",
  "Kansas City, KS",
  "Sunnyvale, CA",
  "Hollywood, FL",
  "Roseville, CA",
  "Charleston, SC",
  "Escondido, CA",
  "Joliet, IL",
  "Jackson, MS",
  "Bellevue, WA",
  "Surprise, AZ",
  "Naperville, IL",
  "Pasadena, TX",
  "Pomona, CA",
  "Bridgeport, CT",
  "Denton, TX",
  "Rockford, IL",
  "Mesquite, TX",
  "Savannah, GA",
  "Syracuse, NY",
  "McAllen, TX",
  "Torrance, CA",
  "Olathe, KS",
  "Visalia, CA",
  "Thornton, CO",
  "Fullerton, CA",
  "Gainesville, FL",
  "Waco, TX",
  "West Valley City, UT",
  "Warren, MI",
  "Hampton, VA",
  "Dayton, OH",
  "Columbia, SC",
  "Orange, CA",
  "Cedar Rapids, IA",
  "Stamford, CT",
  "Victorville, CA",
  "Pasadena, CA",
  "Elizabeth, NJ",
  "New Haven, CT",
  "Miramar, FL",
  "Kent, WA",
  "Sterling Heights, MI",
  "Carrollton, TX",
  "Coral Springs, FL",
  "Midland, TX",
  "Norman, OK",
  "Athens, GA",
  "Santa Clara, CA",
  "Columbia, MO",
  "Fargo, ND",
  "Pearland, TX",
  "Simi Valley, CA",
  "Topeka, KS",
  "Meridian, ID",
  "Allentown, PA",
  "Thousand Oaks, CA",
  "Abilene, TX",
  "Vallejo, CA",
  "Concord, CA",
  "Round Rock, TX",
  "Arvada, CO",
  "Clovis, CA",
  "Palm Bay, FL",
  "Independence, MO",
  "Lafayette, LA",
  "Ann Arbor, MI",
  "Rochester, MN",
  "Hartford, CT",
  "College Station, TX",
  "Fairfield, CA",
  "Wilmington, NC",
  "North Charleston, SC",
  "Billings, MT",
  "West Palm Beach, FL",
  "Berkeley, CA",
  "Cambridge, MA",
  "Clearwater, FL",
  "West Jordan, UT",
  "Richardson, TX",
  "Broken Arrow, OK",
  "Richmond, CA",
  "League City, TX",
  "Manchester, NH",
  "Lakeland, FL",
  "Carlsbad, CA",
  "Antioch, CA",
  "Westminster, CO",
  "High Point, NC",
  "Provo, UT",
  "Lowell, MA",
  "Elgin, IL",
  "Waterbury, CT",
  "Springfield, IL",
  "Gresham, OR",
  "Murrieta, CA",
  "Lewisville, TX",
  "Las Cruces, NM",
  "Lansing, MI",
  "Beaumont, TX",
  "Odessa, TX",
  "Pueblo, CO",
  "Peoria, IL",
  "Downey, CA",
  "Costa Mesa, CA",
  "Inglewood, CA",
  "Miami Gardens, FL",
  "Temecula, CA",
  "Everett, WA",
  "Pompano Beach, FL",
  "Sandy Springs, GA",
  "Green Bay, WI",
  "Tyler, TX",
  "Wichita Falls, TX",
  "Sparks, NV",
  "Boulder, CO",
  "West Covina, CA",
  "Norwalk, CA",
  "Burbank, CA",
  "Daly City, CA",
  "Rialto, CA",
  "Santa Maria, CA",
  "El Monte, CA",
  "Davenport, IA",
  "Vista, CA",
  "Edinburg, TX",
  "Tuscaloosa, AL",
  "Spokane Valley, WA",
  "San Angelo, TX",
  "Vacaville, CA",
  "Clinton, MI",
  "Bend, OR",
  "Greeley, CO",
  "Jurupa Valley, CA",
  "Renton, WA",
  "Hillsboro, OR",
  "Menifee, CA",
  "Nampa, ID",
  "Chico, CA",
  "Mission Viejo, CA",
  "Alabama (statewide)",
  "Alaska (statewide)",
  "Arizona (statewide)",
  "Arkansas (statewide)",
  "California (statewide)",
  "Colorado (statewide)",
  "Connecticut (statewide)",
  "Delaware (statewide)",
  "Florida (statewide)",
  "Georgia (statewide)",
  "Hawaii (statewide)",
  "Idaho (statewide)",
  "Illinois (statewide)",
  "Indiana (statewide)",
  "Iowa (statewide)",
  "Kansas (statewide)",
  "Kentucky (statewide)",
  "Louisiana (statewide)",
  "Maine (statewide)",
  "Maryland (statewide)",
  "Massachusetts (statewide)",
  "Michigan (statewide)",
  "Minnesota (statewide)",
  "Mississippi (statewide)",
  "Missouri (statewide)",
  "Montana (statewide)",
  "Nebraska (statewide)",
  "Nevada (statewide)",
  "New Hampshire (statewide)",
  "New Jersey (statewide)",
  "New Mexico (statewide)",
  "New York (statewide)",
  "North Carolina (statewide)",
  "North Dakota (statewide)",
  "Ohio (statewide)",
  "Oklahoma (statewide)",
  "Oregon (statewide)",
  "Pennsylvania (statewide)",
  "Rhode Island (statewide)",
  "South Carolina (statewide)",
  "South Dakota (statewide)",
  "Tennessee (statewide)",
  "Texas (statewide)",
  "Utah (statewide)",
  "Vermont (statewide)",
  "Virginia (statewide)",
  "Washington (statewide)",
  "West Virginia (statewide)",
  "Wisconsin (statewide)",
  "Wyoming (statewide)",
];

export default US_PLACES;
